<template>
  <div class="content_main padding_row_10 o_s">
    <div class="top flex_sb_s">
      <div class="topTitle" v-if="courseItem">{{ courseItem.courseInfo.courseName }}</div>
      <div :class="nowPlayTime / totalTime > 0.9 ? 'btn activeBtn' : 'btn'" @click="upVideoScheduleOver">我学会了</div>
    </div>
    <div class="center">
      <div class="" id="video" style="width: 100%; height: 100%"></div>
    </div>
  </div>
</template>

<script>
import { training_up, training_video_log, training_up_video_log } from '@/api/question'
export default {
  data() {
    return {
      nowPlayTime: 0, //当前播放时间秒
      totalTime: 0, //视频总时长
      courseItem: '',
      preUrl: '', //视频地址
      player: null,
      isVideo: false,
    }
  },
  mounted() {
    this.courseItem = this.$route.query.objstr;
    this.init();
    window.onbeforeunload = () => {
      this.upVideoSchedule()
    }

  },
  methods: {
    init() {
      training_video_log({
        courseId: this.courseItem.courseId,
        md5: this.courseItem.courseInfo.md5,
      }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.nowPlayTime = parseFloat(res.data.historyLog)
        if (res.data.video) {
          this.preUrl = res.data.video
          this.createVideo()
        } else {
          this.$message.error('视频来源出错')
        }
      })
    },
    //初始化播放器
    createVideo() {
      this.isVideo = true
      var _this = this
      var videoPath = this.preUrl
      var coverUrl = this.courseItem.courseInfo.coverUrl
      var videoObject = {
        container: '#video', //“#”代表容器的ID，“.”或“”代表容器的class
        video: videoPath,
        // video: 'https://ckplayer-video.oss-cn-shanghai.aliyuncs.com/mp4/1_1920x1080.mp4', //视频地址
        poster: coverUrl, //封面图片地址
        controls: false, //是否显示自带控制栏
        rightBar: false, //是否开启右边控制栏
        smallWindows: true, //是否启用小窗口模式
        smallWindowsDrag: true, //小窗口开启时是否可以拖动
        screenshot: false, //截图功能是否开启
        menu: null, //右键菜单
        autoplay: true,
        timeScheduleAdjust: 1, //是否可调节播放进度,0不启用，1是启用，2是只能前进（向右拖动），3是只能后退，4是只能前进但能回到第一次拖动时的位置，5是看过的地方可以随意拖动
        title: this.courseItem.courseInfo.courseName, //视频标题
        barHideTime: 1500, //控制栏隐藏时间
        playbackrateOpen: false, //是否开启控制栏倍速选项
        documentFocusPause: true, //窗口失去焦点后暂停播放
        mouseWheelVolume: 2, //是否启用鼠标滚轮调节音量功能，0=不启用，1=启用，2=全屏时才启用
        keyVolume: 2, //是否启用键盘控制音量调节，0=不启用，1=启用，2=全屏时才启用
        // playbackrateOpen: true, //是否开启控制栏倍速选项
        // playbackrateList: [0.75, 1, 1.5, 2], //倍速配置值
        // seek: 50, //指定跳转到cookie记录的时间，使用该属性必需配置属性cookie
        // cookie: 'abcdefg', //cookie名称,请在同一域中保持唯一
      }
      this.player = new ckplayer(videoObject)


      //监听元数据，obj为一个对象，包含视频的宽高，总时间等信息
      this.player.loadedMetaData((obj) => {
        this.totalTime = obj.duration //获取视频总时间
        this.player.seek(this.nowPlayTime) //跳转指定时间点
        setTimeout(() => {
          this.player.vars('timeScheduleAdjust', 5)
        }, 1000)
      })
      this.player.addListener('play', (callback) => {
        console.log('播放')
      })
      // 添加播放器监听到暂停事件
      this.player.addListener('pause', (callback) => {
        console.log('暂停')
        this.upVideoSchedule()
      })
      //监听当前视频播放位置
      this.player.time((t) => {
        if (t > this.nowPlayTime) {
          this.nowPlayTime = t
        }
      })
    },
    //我学会了
    upVideoScheduleOver() {
      if (this.totalTime == 0) {
        return
      } else {
        if (this.nowPlayTime / this.totalTime > 0.9) {
          this.upVideoSchedule(() => {
            this.$router.go(-1)
          })
        }
      }
    },
    //更新视频进度及状态
    upVideoSchedule(cb = null) {
      if (this.totalTime == 0) {
        return
      } else {
        if (this.nowPlayTime / this.totalTime > 0.9) {
          var status = 2
        } else {
          var status = 1
        }
        var schedule = Math.floor((this.nowPlayTime / this.totalTime) * 100)
      }
      console.log(this.nowPlayTime, this.totalTime)
      training_up({
        courseId: this.courseItem.courseId,
        schedule: schedule || 0,
        status: status,
      }).then((res) => {
        training_up_video_log({
          courseId: this.courseItem.courseId,
          log: this.nowPlayTime,
        }).then((rs) => {
          cb && cb(true)
        })
      })

    },
  },
  beforeDestroy() {
    if (this.isVideo) {
      this.upVideoSchedule()
      this.player.removeListener('play')
      this.player.removeListener('pause')
      this.player.removeListener('time')
      this.player.remove()
      this.player = null
    }
  },
}
</script>

<style lang='less' scoped>
@import '../../../assets/css/mian.less';

.top {
  width: 100%;
  height: 50px;
  float: left;

  .topTitle {
    font-size: 18px;
    font-weight: 600;
  }

  .btn {
    padding: 7px 28px;
    background: #999;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
  }

  .activeBtn {
    background: @mColor  !important;
    cursor: pointer;
  }
}

.center {
  width: 100%;
  height: calc(100% - 70px);
  float: left;
}
</style>